module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-17-f2acf7034f509b88119d35aa939d980b.jpg";